export default {
    
    doCheckVoucher({ commit }, payload){
        //simulated
        
        return new Promise((resolve, reject) => {

            setTimeout(()=>{

                let voucher_data = {}

                if (payload.voucher_code && payload.voucher_code === 'MYSTIC3') {
                    
                    voucher_data = {
                        code: payload.voucher_code,
                        status: 'active',
                        message: '',
                        value: 250.00,
                    }

                    commit('setVoucher', voucher_data)
                    resolve(voucher_data)

                } else if (payload.voucher_code && payload.voucher_code === 'MYSTIC33') {
                    
                    voucher_data = {
                        code: payload.voucher_code,
                        status: 'error',
                        message: 'expired',
                        value: 0.00,
                    }

                    commit('setVoucher', voucher_data)
                    reject(voucher_data)

                } else {

                    voucher_data = {
                        code: payload.voucher_code,
                        status: 'error',
                        message: 'Invallid code',
                        value: 0.00,
                    }

                    commit('setVoucher', voucher_data)
                    reject(voucher_data)

                }

            }, 3000)

        });   
        
        
    },
    
}


// WEBPACK FOOTER //
// ./assets/js/vue/store/actions/vouchersActions.js